import FormButton from "./FormButton";

/**
 * @param {Omit<React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> & { submit: boolean, reset: boolean, noDisable: boolean, formInput: boolean, linkTo: string, outlined: boolean, formless: boolean, legacy: boolean } , "type" | "onClick"> & { onClick: (event: any) => void | Promise }} props
 */
export default function FormIconButton({ className = "", icon, ...rest }) { 
    return (
        <FormButton
            className={`m-0 d-flex justify-content-center align-items-center ${className}`}
            style={{ height: "3rem", aspectRatio: "1 / 1" }}
            {...rest}
        >
            <i className={`bi ${icon} fs-4`} />
        </FormButton>
    );
}